/** Bannière signalant qu'aucune pesée n'a été saisie aujourd'hui (in-app ; les
 * rappels email/push sont côté serveur). */
import { dayKey } from '@/domain';

interface Props {
  weights: readonly { date: string }[];
}

export function WeighInReminder({ weights }: Props) {
  const today = dayKey(new Date());
  const hasToday = weights.some((w) => dayKey(w.date) === today);
  if (hasToday || weights.length === 0) return null;

  return (
    <div
      className="card"
      style={{
        borderLeft: '4px solid var(--warning)',
        background: 'color-mix(in srgb, var(--warning) 10%, var(--surface-1))',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.6rem',
      }}
      role="status"
    >
      <span style={{ fontSize: '1.2rem' }}>⚖️</span>
      <span>Tu n'as pas encore enregistré ta pesée aujourd'hui.</span>
    </div>
  );
}
